import { FieldError } from 'react-hook-form'
import { ValidateStatus } from 'antd/es/form/FormItem'

import getDeepObjectValue from '@utils/object/getDeepObjectValue'
import getDeepKeyPath from '@utils/form/getDeepKeyPath'

export type TGetValidateStatus = (
  errors: {
    [key: string]: FieldError | undefined
  },
  field: string,
) => ValidateStatus

export type TGetValidateStatusInstance = (errors: {
  [key: string]: FieldError | undefined
}) => (field: string) => ReturnType<TGetValidateStatus>

export const getValidateStatus: TGetValidateStatus = (errors, field) => {
  const deepKeyPath = getDeepKeyPath(field)
  const errorField = getDeepObjectValue(errors, deepKeyPath)

  return errorField ? 'error' : 'success'
}

/**
 * Хелпер функция для получения статуса инпута
 * Возвращает другую функцию, в которую нужно передать имя поля
 *
 * Пример использования:
 * const { errors } = useForm<ICompanyEditFields>({ shouldFocusError: false });
 * const inputStatus = getValidateStatusInstance(errors)
 * <FormItem label='Название компании' validateStatus={inputStatus('company_name')}>
 *   ...
 * </FormItem>
 * @param errors - { errors } из useForm (react-hook-form)
 */
const getValidateStatusInstance: TGetValidateStatusInstance = (errors) => {
  return (field) => getValidateStatus(errors, field)
}

export default getValidateStatusInstance
